import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CloseIcon, MailEnvelopeIcon, CheckCircleIcon } from '../Icons/Icons';
import {
  Overlay,
  DialogWrapper,
  CloseButton,
  DialogBox,
  DialogContent,
  IconWrapper,
  CheckBadge,
  Message,
  ConfirmButton,
} from './SendSuccessDialog.styled';

interface SendSuccessDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  officeName: string;
}

export const SendSuccessDialog: React.FC<SendSuccessDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  officeName,
}) => {
  const handleOverlayClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <Overlay onClick={handleOverlayClick}>
      <DialogWrapper>
        <CloseButton onClick={onClose} aria-label="閉じる">
          <CloseIcon />
        </CloseButton>
        <DialogBox role="dialog" aria-modal="true">
          <DialogContent>
            <Message>{`${officeName}に\nメッセージを送信しました。`}</Message>
            <IconWrapper>
              <MailEnvelopeIcon />
              <CheckBadge>
                <CheckCircleIcon />
              </CheckBadge>
            </IconWrapper>
            <ConfirmButton onClick={onConfirm}>
              送信したメッセージを確認する
            </ConfirmButton>
          </DialogContent>
        </DialogBox>
      </DialogWrapper>
    </Overlay>,
    document.body
  );
};
